import Swal from 'sweetalert2';

let isAlertShown = false; // 確保這個狀態變數只在本模組中使用

// 處理 401 Unauthorized 錯誤的函數
export const handleUnauthorizedError = () => {
  if (!isAlertShown) {
    isAlertShown = true; // 設置狀態為已顯示

    Swal.fire({
      icon: 'warning', // 使用正確的屬性 'icon' 指定模態種類
      title: '登入逾時', // 標題
      text: '請重新登入', // 內文
      showCancelButton: false, // 是否顯示取消按鈕
      confirmButtonText: '確定', // 確定按鈕文字
      showCloseButton: false, // 是否於模態右上方顯示"x"關閉按鈕
      // allowEnterKey: false, // 是否允許非聚焦於按鈕時，按下Enter或空白鍵觸發確認
      allowOutsideClick: false, // 是否允許點擊模態外的區域來關閉
      allowEscapeKey: false, // 是否允許按下Esc來關閉模態
      customClass: {
        confirmButton: 'btn btn-primary m-2', // 確定按鈕樣式
        content: 'font-weight-normal', // 內文樣式
      },
      buttonsStyling: false, // 是否使用SweetAlert預設的按鈕樣式，false才能正確套用自定義樣式
      timer: null, // 多少時間後自動關閉，預設為null不自動關閉，單位為毫秒
    }).then((result) => {
      if (result.isConfirmed || result.isDismissed) { // 使用正確的結果判斷條件
        resetAlertStatus(); // 重置狀態
        redirectToLogin(); // 重定向到登錄頁面
      }
    });
  }
};

// 重置顯示狀態
const resetAlertStatus = () => {
  isAlertShown = false;
};

// 重定向到登錄頁面
const redirectToLogin = () => {
  window.location.href = '/login';
};

// 在窗口關閉時重置狀態
window.addEventListener('beforeunload', resetAlertStatus);
